import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isNull from 'lodash/isNull';
import fedHolidays from '@18f/us-federal-holidays';
import moment from 'moment-timezone';
import { getDecisionNodeAtPath } from '../../../../extractFromState';
import { addEdgeToDecisionTreePath, returnToPreviousMacroWizardPath } from '../../../../actions/searchActions';
import { BackButton, NextButton } from '../../../common/buttonsComponents';
import DecisionTreeInfoWidget from '../../DTInfoWidget/DTInfoWidget';
import { Container, InfoWrapper, Title, SubText } from './DTBusinessDayCalculatorNode.styles';
import { ActionsButtonsWrapper, TopContainer } from '../../DecisionTree.styles';
import CustomDateTimePicker from 'components/common/CustomDateTimePicker/CustomDateTimePicker';

const DTBusinessDayCalculatorNode = () => {
  const dispatch = useDispatch();
  const decisionNode = useSelector((state) => getDecisionNodeAtPath(state));

  const [orderDate, setOrderDate] = useState(null);

  const today = moment();
  const disableFutureDt = (current) => {
    return current.isBefore(today);
  };

  const holidaysList = [
    "New Year's Day",
    'Birthday of Martin Luther King, Jr.',
    "Washington's Birthday",
    'Memorial Day',
    'Independence Day',
    'Labor Day',
    'Columbus Day',
    'Thanksgiving Day',
    'Christmas Day',
  ];

  const holidayDates = fedHolidays.allForYear().reduce((dates, holiday) => {
    if (holidaysList.includes(holiday.name)) {
      dates.push(moment(holiday.date).format('MM/DD/YYYY'));
    }

    return dates;
  }, []);

  const enumerateDaysBetweenDates = (start, end) => {
    // dates conversion from local time to Central Time
    const startDate = moment(start).tz('America/Chicago');
    const endDate = moment(end).tz('America/Chicago');

    let now = startDate;
    const dates = [];

    while (now.isBefore(endDate, 'day') || now.isSame(endDate, 'day')) {
      dates.push(now.format('MM/DD/YYYY'));
      now.add(1, 'days');
    }

    return dates;
  };

  const isWeekend = (day) => {
    const SATURDAY = 6;
    const SUNDAY = 0;

    const dayOfWeek = moment(new Date(day)).day();

    return dayOfWeek === SATURDAY || dayOfWeek === SUNDAY;
  };

  const isWithinStartOfDayTime = (day) => {
    // time conversion from local to Central Time
    const time = moment(day).tz('America/Chicago').format('hh:mm A');

    return moment(time, 'hh:mm A').isBefore(moment(decisionNode.startOfDayTime, 'hh:mm A'));
  };

  const handleNextButton = () => {
    const startDate = isWithinStartOfDayTime(orderDate) ? moment(orderDate).add(1, 'days') : orderDate;
    const endDate = isWithinStartOfDayTime(today) ? moment(today).subtract(1, 'days') : today;

    const days = enumerateDaysBetweenDates(startDate, endDate);
    const daysThreshold = Number(decisionNode.daysThreshold);

    if (decisionNode.typeOfMeasurement === 'calendarDays') {
      if (days.length <= daysThreshold) {
        return dispatch(addEdgeToDecisionTreePath('within_threshold'));
      }

      return dispatch(addEdgeToDecisionTreePath('outside_threshold'));
    } else if (decisionNode.typeOfMeasurement === 'businessDays') {
      const businessDays = days.filter((day) => !isWeekend(day) && !holidayDates.includes(day));
      if (businessDays.length <= daysThreshold) {
        return dispatch(addEdgeToDecisionTreePath('within_threshold'));
      }

      return dispatch(addEdgeToDecisionTreePath('outside_threshold'));
    }
  };

  return (
    <TopContainer>
      <InfoWrapper>{!!decisionNode.infoWidget && <DecisionTreeInfoWidget />}</InfoWrapper>
      <Container>
        {decisionNode.title && <Title>{decisionNode.title}</Title>}
        {decisionNode.subText && <SubText>{decisionNode.subText}</SubText>}
        <CustomDateTimePicker
          value={orderDate}
          input={false}
          isValidDate={disableFutureDt}
          onChange={(date) => setOrderDate(date)}
        />
      </Container>
      <ActionsButtonsWrapper>
        <NextButton disabled={isNull(orderDate)} active={!isNull(orderDate)} type="submit" onClick={handleNextButton}>
          NEXT
        </NextButton>
        <BackButton onClick={() => dispatch(returnToPreviousMacroWizardPath())}>BACK</BackButton>
      </ActionsButtonsWrapper>
    </TopContainer>
  );
};

export default DTBusinessDayCalculatorNode;
